import { CSSProperties, useCallback, useState } from 'react';

import useScrollLock from './useScrollLock';

const DROPDOWN_MENU_HEIGHT = 96;
const DROPDOWN_GAP = 4;

const useRowActionsMenu = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [menuStyle, setMenuStyle] = useState<CSSProperties | null>(null);

  useScrollLock(Boolean(isOpen && menuStyle));

  const openMenu = useCallback((event: React.MouseEvent<HTMLElement>) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const openUpwards = window.innerHeight - rect.bottom < DROPDOWN_MENU_HEIGHT;

    setMenuStyle({
      right: window.innerWidth - rect.right,
      ...(openUpwards
        ? { bottom: window.innerHeight - rect.top + DROPDOWN_GAP }
        : { top: rect.bottom + DROPDOWN_GAP }),
    });
    setIsOpen(true);
  }, []);

  const closeMenu = useCallback(() => setIsOpen(false), []);

  return { isOpen, menuStyle, openMenu, closeMenu };
};

export default useRowActionsMenu;
